export default __webpack_public_path__ + "static/media/payment.b153534a.png";